import React from 'react'
import styled from 'styled-components'
import { List } from 'types/graphql'
import { media } from 'utils/media'
import { Pill as OriginalPill } from 'lib/Pill'
import { MaxWidthContainer } from 'lib/Section'
import { useBrandCarouselContext } from '../context/BrandCarouselContext'

const Categories = styled.ul`
  display: flex;
  gap: 16px;
  padding: 16px var(--wide-grid-spacing);
  margin: 8px 0;
  max-width: 100%;
  flex-wrap: wrap;

  ${media.tabletDown} {
    flex-wrap: nowrap;
    overflow-x: scroll;
    overscroll-behavior-x: contain;
    ::-webkit-scrollbar {
      display: none;
    }
    -webkit-overflow-scrolling: touch;
  }
`

const Pill = styled(OriginalPill)`
  white-space: nowrap;
`

export const BrandCarouselCategories = () => {
  const { filter, setFilter, lists } = useBrandCarouselContext()

  const onDefaultClick = () => {
    window.analytics.track('Carousel Category Clicked', {
      listId: null,
      title: 'For you'
    })
    setFilter(null)
  }

  const onListClick = (list?: Pick<List, 'id' | 'title'> | null) => () => {
    if (list) {
      window.analytics.track('Carousel Category Clicked', {
        listId: list.id,
        listTitle: list.title
      })
      setFilter(list.id)
    }
  }

  return (
    <MaxWidthContainer>
      <Categories>
        <li>
          <Pill onClick={onDefaultClick} selected={filter === null} label="For you" />
        </li>

        {lists.map((list) => (
          <li key={list?.id}>
            <Pill onClick={onListClick(list)} selected={filter === list.id} label={list.title} />
          </li>
        ))}
      </Categories>
    </MaxWidthContainer>
  )
}
